import { createSelector } from 'reselect';

import { selectIsAdminTypeUser, selectIsFirebaseProfileLoaded } from '../../selectors/auth';

export const selectIsCsRoleResolved = createSelector(selectIsFirebaseProfileLoaded, Boolean);

export const selectIsCsBulkSendAllowed = createSelector(
  selectIsCsRoleResolved,
  selectIsAdminTypeUser,
  (isResolved, isAdminTypeUser): boolean => !isResolved || isAdminTypeUser,
);

export const selectIsCsBulkSendBlocked = createSelector(
  selectIsCsRoleResolved,
  selectIsCsBulkSendAllowed,
  (isResolved, isAllowed): boolean => isResolved && !isAllowed,
);
